import { t } from 'i18next';
import { useColumns } from '../../../../hook/useColumns';
import ColumnOrderRowOptions from './ColumnOrderRowOptions';
import { SetStateAction } from 'react';
import close from '../../../../assets/img/png/health-monitor/close-button.png';
import { DndProvider } from 'react-dnd';
import { MultiBackend } from 'react-dnd-multi-backend';
import { HTML5toTouch } from 'rdndmb-html5-to-touch';
import { Visibility } from '../../../../enum/Visibility';

interface ColumnOrderProps {
  showDropdown: boolean;
  setShowDropdown: React.Dispatch<SetStateAction<boolean>>;
}

const ColumnOrderDropdown: React.FC<ColumnOrderProps> = ({ showDropdown, setShowDropdown }) => {
  const { pinnedColumns, unpinnedColumns } = useColumns();

  return (
    <DndProvider backend={MultiBackend} options={HTML5toTouch}>
      <div className={`column_order_dropdown ${showDropdown ? Visibility.VISIBLE : Visibility.HIDDEN}`}>
        <div className="column_order_header">
          <span className="title">
            {t('statisticPage.header.columnOrder.title')}
            <button className="menu" onClick={() => setShowDropdown(false)}>
              <img src={close} alt="menu close" />
            </button>
          </span>

          <hr />
          <span className="pinned">
            {pinnedColumns.length} {t('statisticPage.header.columnOrder.pinned')}
          </span>
        </div>

        <div className="options_container">
          {pinnedColumns.map((col, i) => (
            <ColumnOrderRowOptions key={col.name} column={col} index={i} />
          ))}

          {pinnedColumns.length > 0 && unpinnedColumns.length > 0 && <hr />}

          {unpinnedColumns.map((col, i) => (
            <ColumnOrderRowOptions key={col.name} column={col} index={i} />
          ))}
        </div>
      </div>
    </DndProvider>
  );
};

export default ColumnOrderDropdown;
